import {inject, injectable} from 'inversify'
import {DI} from '@/src/config/di/types'
import type {StorageAdapter} from '@/src/core/domain/data/storage'
import {FavouriteProductId} from '@/src/features/favourite/core/types'
import {FavouriteRepositoryInterface} from "@/src/core/application/favourite";

@injectable()
export class FavouriteRepository implements FavouriteRepositoryInterface {
  @inject(DI.StorageAdapter)
  storage!: StorageAdapter

  storageKey = 'fav_items'

  async set(items: FavouriteProductId[]): Promise<void> {
    await this.storage.setItem(this.storageKey, items)
  }

  async add(productId: Id) {
    const favouriteList = await this.getAll()
    await this.set([...favouriteList, productId])
  }

  async remove(productId: Id) {
    const favouriteList = await this.getAll()

    const index = favouriteList.indexOf(productId)

    favouriteList.splice(index, 1)

    await this.set(favouriteList)
  }

  async getAll(): Promise<FavouriteProductId[]> {
    const favouriteList = await this.storage.getItem<FavouriteProductId[]>(this.storageKey)

    if (!favouriteList) {
      return []
    }

    return favouriteList
  }
}
